import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProviderGroupSearchParams } from 'src/app/shared/interfaces/provider/provider-group.interfaces';
import {
  IUserAccountDTO,
  IUserGroupNested,
} from 'src/app/shared/interfaces/user/user.interface';

@Component({
  selector: 'app-add-group-to-user-modal',
  templateUrl: './add-group-to-user-modal.component.html',
})
export class AddGroupToUserModalComponent implements OnInit {
  @Input() userGroups?: IUserGroupNested[];
  @Input() userAccounts?: IUserAccountDTO[];

  vendorFiltersForm: UntypedFormGroup;
  checkedProviderGroups?: IUserGroupNested[];
  searchParams: ProviderGroupSearchParams;
  isLoading: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.vendorFiltersForm = this.fb.group({
      name: [''],
      groupId: [''],
    });

    this.checkedProviderGroups = this.userGroups;
  }

  doSearch() {
    const params = this.vendorFiltersForm.value;
    this.searchParams = params;
  }

  addGroups() {
    this.activeModal.close(this.checkedProviderGroups);
  }

  setGroups(groups: IUserGroupNested[]) {
    this.checkedProviderGroups = groups;
  }

  close() {
    this.activeModal.dismiss();
  }
}
